<template>
  <div id="machine">
  <!-- 面包线导航 -->
    <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/welcome' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>机器人列表</el-breadcrumb-item>
        <el-breadcrumb-item>地图列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card >
        <!-- 第一行筛选框 -->
        <el-row :gutter="20">
                <el-col :span="5" >
                    <el-input placeholder="地图编号" v-model="dataMap.mapNo" class="m-l-30 ell-input"> </el-input>
                </el-col>
        </el-row>
        <!-- 第二行筛选框 -->
        <el-row :gutter="20" >
                  <!-- 创建时间 -->
            <el-col align="middle" >
                <el-button type="primary" @click="searchDataMaps()">查询</el-button>
                <el-button type="info" @click="clearParams()">重置</el-button>
                 <el-button type="primary" @click="returnMissionRobot()">返回</el-button>
            </el-col>   
        </el-row>
        <!-- 用户列表区域 -->
        <el-table :data="dataMapList" border  stripe  :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}">
            <el-table-column label="序号" type="index" width="50"></el-table-column>
            <el-table-column label="机器人编号" prop="robotNo" width="400"></el-table-column>
            <el-table-column label="地图编号" prop="mapNo" width="250"></el-table-column>
            <el-table-column label="使用状态" prop="isUser" width="250">
                <template slot-scope="scope">
                   <span v-if="scope.row.isUser==0" >
                            否
                   </span>
                   <span v-if="scope.row.isUser==1" style="color:blue">
                            是
                   </span>
                </template>
            </el-table-column>
            <el-table-column label="创建时间" prop="createTime" width="200"></el-table-column>
            <el-table-column label="操作" prop="" width="220">
                <template slot-scope="scope">
                    <span >
                        <el-tooltip effect="dark" content="路网信息" placement="top" :enterable="false"  >  
                            <el-button type="primary" icon="el-icon-view" size="mini" @click="showMap(scope.row)">路网信息</el-button>
                        </el-tooltip>
                    </span>
                    <span >
                        <el-tooltip effect="dark" content="任务列表" placement="top" :enterable="false"  >  
                            <el-button type="warning"  size="mini" @click="jumpTask(scope.row)">任务列表</el-button>
                        </el-tooltip>
                    </span>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog  title="路网信息" :visible.sync="showMapDialogVisible"   width="45%"  @close="showMapDialogClose">
            <!--地图信息展示-->
           <canvas id="mycanvas" class="mycanvasDiv" alt="" style="height: auto;width: 100%;" />
        </el-dialog>
         <!-- 分页区间 -->
        <el-pagination   @current-change="handleCurrentChange"  :current-page.sync="dataMap.num"  
                :page-size="10"  layout="total, prev, pager, next"  :total="total">
        </el-pagination>
    </el-card >
  </div>
</template>

<script>

export default {
  name: 'machine',
  data(){
      return {
          dataMap :{
              robotNo:'',
              mapNo:'',
              num:1,
          },
          showMapDialogVisible:false,
          dataMapList:[],
          total:0,
          mapDate:null,
          imageWidth:'',
          imageHeight:'',
          resolution:'',
          origin_x:'',
          origin_y:'',
          globleX:'',
          globleY :'',
          gcanvas:null,
          goalList:[],
      }
  },
   //生命周期函数
  created(){
     this.searchDataMaps();
  },
  methods:{
        //展示地图信息
        showMap(val){
            this.$http.get('map/findMapById',{params :{ mapId : val.id }})
            .then(response => {
                    if (response.data.code === 200) {
                        this.showMapDialogVisible=true;
                        this.mapDate=response.data.result
                        this.downloadOFile(this.mapDate.orginUrl,this.mapDate,"mycanvas");
                        
                        return
                    }else{
                        this.singlelineFlag=true //单线标记
                        console.log("未查询到地图!")
                    }
                }).catch(failResponse => {
                
            })
            //this.downloadOFile(this.mapDate.orginUrl,this.mapDate,"editmycanvas");
        },
        //关闭地图显示
        showMapDialogClose(){
            this.showMapDialogVisible=false;
            this.mapDate=null;
            this.imageWidth='';
            this.imageHeight='';
            this.resolution='';
            this.origin_x='';
            this.origin_y='';
            this.globleX='';
            this.globleY ='';
            this.gcanvas=null;
            this.goalList=[];
        },
        //返回页面
        returnMissionRobot(){
              //this.$router.replace({path: '/missionPlanning'})
              this.$router.replace({path: '/robotManage'+'?id='+this.$route.query.id})
        },
        jumpTask(obj){
            this.$router.replace({path: '/task?robotNo='+obj.robotNo+'&mapId='+obj.id})
        },
        searchDataMaps(){
            var check = /[`~!@#$%^&*()\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/
            if(check.test(this.dataMap.mapNo)){
                return this.$message.error("请输入非特殊字符!");
            }
            //this.robotNo=this.$route.query.robotNo;
            this.robotNo=this.$route.query.robotNo;
            this.$http.get('map/selectRobots',{params :{ robotNo : this.robotNo,mapNo : this.dataMap.mapNo,pageNum :this.dataMap.num }})
            .then(response => {
                    if (response.data.code === 200) {
                        this.dataMapList=response.data.result.data
                        this.total=response.data.result.total
                    }else{
                        return this.$message.error(response.data.message);
                    }
                }).catch(failResponse => {
                
            })

       },
       clearParams(){
           this.dataMap.robotNO='';
           this.dataMap.mapNo='';
       },
       handleCurrentChange(page){
            this.dataMap.num=page;
            this.searchDataMaps();
       },
       // 下载原点文件
       downloadOFile(url,dataMap,mycanva) {
        console.log('下载原点文件', url)
        this.$http.get(window.location.origin+url+'?a='+(new Date()).toString)
            .then(res => {
                const blob = new Blob([res.data])
                const reader = new FileReader()
                const that = this
                reader.readAsText(blob, 'utf-8')
                reader.onload = function() {
                console.log(reader.result)
                that.resolution = reader.result.substring(reader.result.indexOf('resolution:') + 'resolution:'.length, reader.result.indexOf('origin:'))
                var tempOrigin = reader.result.substring(reader.result.indexOf('[') + 1, reader.result.indexOf(']'))
                console.log(tempOrigin)
                var originArr = tempOrigin.split(',')
                that.origin_x = originArr[0]
                that.origin_y = originArr[1]
                console.log(dataMap.mapPngUrl)
                that.doDraw(dataMap.mapPngUrl+'?a='+(new Date()).toString,dataMap,mycanva)
            }  
            }).catch(res => {
                
            })
        },
         // imageUrl为后台提供图片地址
        doDraw(imageUrl,dataMap,mycanva) {
            // 获取canvas
            var canvas = document.getElementById(mycanva)
            // 由于弹窗，确保已获取到
            var a = setInterval(() => {
            // 重复获取
                canvas = document.getElementById(mycanva)
                if (!canvas) {
                    return false
                } else {
                clearInterval(a)
                // 可以理解为一个画笔，可画路径、矩形、文字、图像
                var context = canvas.getContext('2d')
                var scale = window.devicePixelRatio
                context.scale(scale, scale)
                var img = new Image()
                img.src = imageUrl
                const that = this
                // 加载图片
                img.onload = function() {
                    if (img.complete) {
                    // 根据图像重新设定了canvas的长宽
                    canvas.setAttribute('width', img.width)
                    canvas.setAttribute('height', img.height)
                    that.imageWidth = canvas.width
                    that.imageHeight = canvas.height
                    that.gcanvas = canvas
                    // 绘制图片
                    context.drawImage(img, 0, 0, img.width, img.height)
                    //起始点坐标计算公式
                    var x1 = (0 - that.origin_x) / that.resolution
                    var y1 = that.imageHeight - (0 - that.origin_y) / that.resolution
                    //画出原点坐标
                    that.doDrawLine(context, x1 - 10, y1, x1 + 10, y1, 'red', 2)
                    that.doDrawLine(context, x1, y1 - 10, x1, y1 + 10, 'red', 2)
                    //画轨迹
                    that.downloadRoadFile(dataMap.roadUrl,dataMap)
                    }
                  }
                }
            }, 10)
        },
          // 橡皮筋画线
        drawingLine(context, loc, ev) {
            context.beginPath()
            context.moveTo(ev.x, ev.y)
            context.lineTo(loc.x1, loc.y1)
            context.stroke()
        },
        // 画线doDra
        doDrawLine(context, x1, y1, x2, y2, color, line) {
            context.beginPath()
            context.moveTo(x1, y1)
            context.lineTo(x2, y2)
            context.strokeStyle = color
            context.lineWidth = line
            context.stroke()
        },
        //根据轨迹文件画图
        downloadRoadFile(url,dataMap) {
            console.log('加载xml文件')
            this.$http.get(window.location.origin+url+'?a='+(new Date()).toString)
                .then(res => {
                        const blob = new Blob([res.data])
                        const reader = new FileReader()
                        const that = this
                        reader.readAsText(blob, 'utf-8')
                        reader.onload = function() {
                        var map = that.$x2js.xml2js(reader.result)  
                        var xmlList = map.map.vertex
                        var lineXmlList = map.map.edge
                        var tempList = []
                        var lineist = []
                        for (var i = 0; i < xmlList.length; i++) {
                            var tempString = xmlList[i]
                            var Id =tempString._id
                            var id=Id*1
                            var X =tempString._x
                            var Y =tempString._y
                            that.goalList.push({ id, X, Y })
                            tempList.push({ Id, X, Y })
                            console.log(that.goalList)
                        }
                        if(lineXmlList.length===undefined){
                            var lineString = lineXmlList
                            var lid = lineString._id
                            var src_id = lineString._src_id
                            var dst_id = lineString._dst_id
                            lineist.push({ lid, src_id, dst_id })
                        }else{
                            for (var k = 0; k < lineXmlList.length; k++) {
                                var lineString = lineXmlList[k]
                                var lid = lineString._id
                                var src_id = lineString._src_id
                                var dst_id = lineString._dst_id
                                lineist.push({ lid, src_id, dst_id })
                            }
                        }
                        
                        dataMap.dotList = tempList
                        that.dotList=tempList
                        dataMap.lineList = lineist
                        for (var j = 0; j < lineist.length; j++) {
                            var context = that.gcanvas.getContext('2d')
                            // var scale = window.devicePixelRatio
                            // context.scale(scale, scale)
                            var m = parseInt(lineist[j].src_id)
                            var n = parseInt(lineist[j].dst_id)
                            var x = parseFloat(dataMap.dotList[m].X)
                            var y = parseFloat(dataMap.dotList[m].Y)
                            x = (x - that.origin_x) / that.resolution
                            y = that.imageHeight - (y - that.origin_y) / that.resolution
                            var x2 = parseFloat(dataMap.dotList[n].X)
                            var y2 = parseFloat(dataMap.dotList[n].Y)
                            x2 = (x2 - that.origin_x) / that.resolution
                            y2 = that.imageHeight - (y2 - that.origin_y) / that.resolution
                            that.doDrawLine(context, x, y, x2, y2, 'blue', 2)
                        }
                        for (var l = 0; l < tempList.length; l++) {
                            var context1 = that.gcanvas.getContext('2d')
                            // var scale1 = window.devicePixelRatio
                            // context1.scale(scale1, scale1)
                            var x1 = parseFloat(dataMap.dotList[l].X)
                            var y1 = parseFloat(dataMap.dotList[l].Y)
                            x1 = (x1 - that.origin_x) / that.resolution
                            y1 = that.imageHeight - (y1 - that.origin_y) / that.resolution
                            that.doDrawSicle(context1, x1, y1, 'green', 3,l)
                        }
                    
                    }
                }).catch((error) => {
                    console.log(error)
                })
        },
             //机器人原点
        doDrawSiclePath(context, x, y, color, line) {
            context.beginPath()
            context.arc(x, y, line / 2, 2 * Math.PI, 0, true)
            context.lineWidth = line
            context.strokeStyle = color
            context.shadowOffsetX = 0
            context.shadowOffsetY = 0
            context.shadowColor = color
            context.shadowBlur = 0
            context.stroke()
        },
        // 画大圆点
        doDrawSicle(context, x, y, color, line,index) {
            context.beginPath()
            context.arc(x, y, line / 2, 2 * Math.PI, 0, true)
            context.lineWidth = line
            context.strokeStyle = color
            context.shadowOffsetX = 0
            context.shadowOffsetY = 0
            context.font="15px lighter arial";
            context.fillText(index,x,y);
            context.shadowColor = color
            context.shadowBlur = 0
            context.stroke()
        },
  }
  
}
</script>

<style lang="less" scoped>
.el-input {
    width: 150px;
}
.elll-input {
    width: 100px;
}
.ell-input {
    width: 200px;
}
.m-l-30 {
  margin-left: 30px !important;
}

.el-row {
    margin-bottom: 20px;
    display: flex;
    flex-wrap: wrap
}

.ell-row {
    margin-bottom: 40px;
    display: flex;
    flex-wrap: wrap
}
html,body,.XSDFXPage{
        width: 50%;
        height: 50%;
        overflow: hidden;
        margin: 0px auto;
        font-family: "微软雅黑";
}
.map {
        width: 100%;
        height: 400px;
}
.el-table{
    font-size: 10px;
    height:'20px';
    padding:'0px'
}
 

</style>


// WEBPACK FOOTER //
// src/components/robot/TaskMap.vue